import type { DeviceType } from './types';

// Money + duration formatting is shared app-wide; see src/lib/format.
export { formatPrice, formatWarranty } from '@/lib/format';

const DEVICE_TYPE_LABELS: Record<DeviceType, string> = {
  dm_device: 'DM Device',
  cropx: 'CropX',
  other: 'Other',
};

export function formatDeviceType(type: DeviceType): string {
  return DEVICE_TYPE_LABELS[type];
}

/** The noun the create-success toast names the new device by (ADO 113100, step 2: each toast
 *  reflects the device type — "DM Device added successfully", "CropX Device added successfully").
 *  Kept apart from `DEVICE_TYPE_LABELS`, which is the radio/column label and reads "CropX" alone. */
const DEVICE_TYPE_NOUNS: Record<DeviceType, string> = {
  dm_device: 'DM Device',
  cropx: 'CropX Device',
  other: 'Other Device',
};

export function deviceTypeNoun(type: DeviceType): string {
  return DEVICE_TYPE_NOUNS[type];
}
